module.exports = __webpack_public_path__ + "static/media/traffic-moderate.842f603e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/megabus/traffic-moderate.svg
// module id = 759
// module chunks = 0